module.exports = __webpack_public_path__ + "img/product01-xindai.045d7806.svg";